import { useMemo } from 'react';

import { useStudyGuard } from '@/shared/guard';
import { useAppsStudies } from '@/shared/hook';
import { isNotEmpty } from '@/shared/util';

import { extractPreviousStudyResults, getMostRecentStudy } from '../util';

export function useAppsPreviousStudies() {
  const {
    radiologistScan: { scanDate },
    studyId,
  } = useStudyGuard();

  const { studies } = useAppsStudies();

  const currentStudy = useMemo(
    () => studies.find((study) => study.studyID === studyId),
    [studies, studyId],
  );

  const previousStudies = useMemo(
    () => studies.filter(({ studyID }) => studyID !== studyId),
    [studies, studyId],
  );

  const { mostRecentPreviousStudy, previousStudyResults } = useMemo(
    () => ({
      mostRecentPreviousStudy: getMostRecentStudy(previousStudies, scanDate),
      previousStudyResults: extractPreviousStudyResults(previousStudies, scanDate),
    }),
    [previousStudies, scanDate],
  );

  const hasPreviousStudyResults = useMemo(
    () => isNotEmpty(previousStudyResults),
    [previousStudyResults],
  );

  return useMemo(
    () => ({
      currentStudy,
      hasPreviousStudyResults,
      isError: false,
      mostRecentPreviousStudy,
      previousStudyResults,
      studies,
    }),
    [currentStudy, hasPreviousStudyResults, mostRecentPreviousStudy, previousStudyResults, studies],
  );
}
